"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var guide_1 = require("../models/guide");
var guide_state_1 = __importDefault(require("./guide-state"));
var activity_1 = require("../models/activity");
var park_state_1 = __importDefault(require("./park-state"));
var breathe_state_1 = __importDefault(require("./breathe-state"));
var memorize_state_1 = __importDefault(require("./memorize-state"));
var feed_state_1 = __importDefault(require("./feed-state"));
var clean_state_1 = __importDefault(require("./clean-state"));
var customize_state_1 = __importDefault(require("./customize-state"));
var inbox_state_1 = __importDefault(require("./inbox-state"));
var color_1 = require("../utilities/color");
var breath_emitter_1 = __importDefault(require("../emitters/breath-emitter"));
var activity_button_1 = __importDefault(require("../views/activity-button"));
var meter_1 = __importDefault(require("../views/meter"));
var stack_container_1 = __importStar(require("../views/stack-container"));
var game_area_1 = require("../utilities/game-area");
var progress_bar_1 = __importDefault(require("../views/progress-bar"));
var gift_button_1 = __importDefault(require("../views/gift-button"));
var calculator_1 = __importStar(require("../models/calculator"));
var time_conversion_1 = require("../utilities/time-conversion");
var name_state_1 = __importDefault(require("./name-state"));
var scoring_state_1 = __importDefault(require("./scoring-state"));
var gesture_recognizer_1 = __importDefault(require("../utilities/gesture-recognizer"));
var i18next_1 = __importDefault(require("i18next"));
var HomeState = /** @class */ (function (_super) {
    __extends(HomeState, _super);
    function HomeState(app, client, guide, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._guide = guide;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(HomeState.prototype, "breathEmitter", {
        get: function () {
            if (!this._breathEmitter) {
                this._breathEmitter = new breath_emitter_1.default();
            }
            return this._breathEmitter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "activityButtons", {
        get: function () {
            var e_1, _a;
            if (!this._activityButtons) {
                this._activityButtons = [];
                try {
                    for (var _b = __values(Object.values(activity_1.ACTIVITY_TYPE)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var type = _c.value;
                        if (type == activity_1.ACTIVITY_TYPE.PET) {
                            continue;
                        }
                        var button = new activity_button_1.default(this._app.loader.resources.ui.textures, type, this.onActivity.bind(this, type));
                        this._activityButtons.push(button);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            return this._activityButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "activityContainer", {
        get: function () {
            if (!this._activityContainer) {
                this._activityContainer = new stack_container_1.default(this.activityButtons, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.TRAILING,
                    spacing: 4
                });
                this._activityContainer.position.set(game_area_1.GAME_WIDTH - this.activityContainer.width, game_area_1.GAME_SAFE_AREA.bottom - this.activityContainer.height - 87);
            }
            return this._activityContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "calmnessMeter", {
        get: function () {
            if (!this._calmnessMeter) {
                this._calmnessMeter = new meter_1.default(i18next_1.default.t("meter_calmness"));
            }
            return this._calmnessMeter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "nutritionMeter", {
        get: function () {
            if (!this._nutritionMeter) {
                this._nutritionMeter = new meter_1.default(i18next_1.default.t("meter_nutrition"));
            }
            return this._nutritionMeter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "hygieneMeter", {
        get: function () {
            if (!this._hygieneMeter) {
                this._hygieneMeter = new meter_1.default(i18next_1.default.t("meter_hygiene"));
            }
            return this._hygieneMeter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "energyMeter", {
        get: function () {
            if (!this._energyMeter) {
                this._energyMeter = new meter_1.default(i18next_1.default.t("meter_energy"));
            }
            return this._energyMeter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "meterContainer", {
        get: function () {
            if (!this._meterContainer) {
                this._meterContainer = new stack_container_1.default([
                    this.calmnessMeter,
                    this.nutritionMeter,
                    this.hygieneMeter,
                    this.energyMeter
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 20
                });
                this._meterContainer.position.set((game_area_1.GAME_WIDTH - this._meterContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 15);
            }
            return this._meterContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "nameLabel", {
        get: function () {
            if (!this._nameLabel) {
                this._nameLabel = new PIXI.Text("");
                this._nameLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    fontSize: 35,
                    fill: color_1.COLOR.WHITE
                };
                this._nameLabel.interactive = true;
                this._nameLabel.on("pointerdown", this.onName.bind(this));
            }
            return this._nameLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "giftBar", {
        get: function () {
            if (!this._giftBar) {
                this._giftBar = new progress_bar_1.default();
            }
            return this._giftBar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "giftButton", {
        get: function () {
            if (!this._giftButton) {
                this._giftButton = new gift_button_1.default(this._app.loader.resources.ui.textures, this.onGift.bind(this));
            }
            return this._giftButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "countdownLabel", {
        get: function () {
            if (!this._countdownLabel) {
                this._countdownLabel = new PIXI.Text("");
                this._countdownLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 21,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._countdownLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "statusContainer", {
        get: function () {
            if (!this._statusContainer) {
                this._statusContainer = new stack_container_1.default([
                    this.nameLabel,
                    this.giftBar,
                    this.countdownLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 6
                });
                this._statusContainer.position.set((game_area_1.GAME_WIDTH - this._statusContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.bottom - this._statusContainer.height - 10);
            }
            return this._statusContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HomeState.prototype, "gestureRecognizer", {
        get: function () {
            var _this = this;
            if (!this._gestureRecognizer) {
                this._gestureRecognizer = new gesture_recognizer_1.default();
                this._gestureRecognizer
                    .onTouchDown(function () {
                    if (calculator_1.default.hatched(_this._client.dragon.status.stage) && _this.checkActivityGuide(activity_1.ACTIVITY_TYPE.PET)) {
                        return;
                    }
                })
                    .onTouchUp(function () {
                    if (_this._gestureRecognizer.totalScrubTime >= 2000) {
                        _this._client.adjustMeters({
                            calmness: 20,
                            nutrition: 0,
                            hygiene: 0,
                            energy: 0
                        });
                        _this._client.award(calculator_1.PET_XP);
                        _this._client.synchronize();
                        _this._client.sendEvent("home_petted");
                    }
                })
                    .onScrubBegin(function () {
                    _this._dragonContainer.setRubAnimation();
                })
                    .onScrubEnd(function () {
                    _this._dragonContainer.setIdleAnimation();
                })
                    .onLongPress(this.roar.bind(this));
            }
            return this._gestureRecognizer;
        },
        enumerable: false,
        configurable: true
    });
    HomeState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.activityContainer);
        this._app.stage.addChild(this.meterContainer);
        this._app.stage.addChild(this.statusContainer);
        this._app.stage.addChild(this.giftButton);
        var giftBarPosition = this._app.stage.toLocal(this.giftBar.position, this.statusContainer);
        this.giftButton.position.set(giftBarPosition.x + this.giftBar.width - (this.giftButton.width * 0.5), giftBarPosition.y + ((this.giftBar.height - this.giftButton.height) * 0.5));
        this._dragonContainer.interactive = true;
        this.gestureRecognizer.addTo(this._dragonContainer);
        this._dragonContainer.breathSlot.addChild(this.breathEmitter.parent);
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this._client.sendEvent("home_entered");
    };
    HomeState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.activityContainer);
        this._app.stage.removeChild(this.meterContainer);
        this._app.stage.removeChild(this.statusContainer);
        this._app.stage.removeChild(this.giftButton);
        this._dragonContainer.interactive = false;
        this.gestureRecognizer.removeFromContainer();
        this._dragonContainer.breathSlot.removeChild(this.breathEmitter.parent);
        this.breathEmitter.emit = false;
        this.breathEmitter.cleanup();
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    HomeState.prototype.update = function (deltaTime) {
        this.updateActivityButtons();
        var stage = this._client.dragon.status.stage;
        var hatched = calculator_1.default.hatched(stage);
        var now = new Date();
        if (hatched) {
            var lastVisit = this._client.dragon.status.saved;
            var meterDecay = calculator_1.default.meterDecay(stage, lastVisit, now);
            var meters = this._client.dragon.meters;
            this.calmnessMeter.progressRing.percentage = meters.calmness - meterDecay;
            this.nutritionMeter.progressRing.percentage = meters.nutrition - meterDecay;
            this.hygieneMeter.progressRing.percentage = meters.hygiene - meterDecay;
            this.energyMeter.progressRing.percentage = meters.energy - meterDecay;
        }
        else {
            this.calmnessMeter.progressRing.percentage = null;
            this.nutritionMeter.progressRing.percentage = null;
            this.hygieneMeter.progressRing.percentage = null;
            this.energyMeter.progressRing.percentage = null;
        }
        var name = this._client.dragon.status.name;
        this.nameLabel.text = (name === null || name === void 0 ? void 0 : name.trim()) ? name : i18next_1.default.t("name_none");
        this.giftBar.setPercentage(calculator_1.default.levelPercentage(this._client.dragon.status.level, this._client.dragon.status.xp));
        var evolutionTimeRemaining = calculator_1.default.timeUntilNextStageEvent(this._client.dragon.quit.start, now);
        if (evolutionTimeRemaining == null) {
            this.countdownLabel.text = i18next_1.default.t("fully_evolved");
        }
        else if (!hatched) {
            this.countdownLabel.text = i18next_1.default.t("hatches_in") + ": " + (0, time_conversion_1.timeConversion)(evolutionTimeRemaining);
        }
        else {
            this.countdownLabel.text = i18next_1.default.t("evolves_in") + ": " + (0, time_conversion_1.timeConversion)(evolutionTimeRemaining);
        }
        this.statusContainer.layoutChildren();
        this.gestureRecognizer.update(deltaTime);
        if (this._client.activityType) {
            this.onActivity(this._client.activityType);
            this._client.activityType = null;
        }
    };
    HomeState.prototype.updateActivityButtons = function () {
        var _a, _b;
        for (var i = 0; i < this.activityButtons.length; i++) {
            var button = this.activityButtons[i];
            var type = Object.values(activity_1.ACTIVITY_TYPE)[i];
            button.active = !this.activityRequiresHatched(type) || calculator_1.default.hatched(this._client.dragon.status.stage);
            switch (type) {
                case activity_1.ACTIVITY_TYPE.INBOX:
                    button.visible = ((_a = this._client.inbox) === null || _a === void 0 ? void 0 : _a.reactions.length) > 0;
                    break;
                case activity_1.ACTIVITY_TYPE.PARK:
                    button.visible = ((_b = this._client.park) === null || _b === void 0 ? void 0 : _b.dragons.length) > 0;
                    break;
                default:
                    break;
            }
        }
    };
    HomeState.prototype.activityButton = function (type) {
        return new activity_button_1.default(this._app.loader.resources.ui.textures, type, this.onActivity.bind(this, type));
    };
    HomeState.prototype.activityRequiresHatched = function (type) {
        switch (type) {
            case activity_1.ACTIVITY_TYPE.BREATHE:
            case activity_1.ACTIVITY_TYPE.CLEAN:
            case activity_1.ACTIVITY_TYPE.FEED:
                return true;
            default:
                return false;
        }
    };
    HomeState.prototype.activityStateClass = function (type) {
        switch (type) {
            case activity_1.ACTIVITY_TYPE.INBOX:
                return inbox_state_1.default;
            case activity_1.ACTIVITY_TYPE.PARK:
                return park_state_1.default;
            case activity_1.ACTIVITY_TYPE.BREATHE:
                return breathe_state_1.default;
            case activity_1.ACTIVITY_TYPE.MINIGAMES:
                return memorize_state_1.default;
            case activity_1.ACTIVITY_TYPE.CLEAN:
                return clean_state_1.default;
            case activity_1.ACTIVITY_TYPE.FEED:
                return feed_state_1.default;
            case activity_1.ACTIVITY_TYPE.CUSTOMIZE:
                return customize_state_1.default;
            default:
                return null;
        }
    };
    HomeState.prototype.activityGuidePages = function (type) {
        switch (type) {
            case activity_1.ACTIVITY_TYPE.INBOX:
                return [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_inbox_1")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_inbox_2"))
                    ]
                ];
            case activity_1.ACTIVITY_TYPE.PARK:
                return [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_park_1")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_park_2"))
                    ], [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_park_3")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_park_4"))
                    ]
                ];
            case activity_1.ACTIVITY_TYPE.BREATHE:
                return [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_breathe_1")),
                    ]
                ];
            case activity_1.ACTIVITY_TYPE.MINIGAMES:
                return [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_minigames_1")),
                    ]
                ];
            case activity_1.ACTIVITY_TYPE.CLEAN:
                return [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_clean_1"))
                    ]
                ];
            case activity_1.ACTIVITY_TYPE.FEED:
                return [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_feed_1"))
                    ]
                ];
            case activity_1.ACTIVITY_TYPE.CUSTOMIZE:
                return [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_customize_1")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_customize_2")),
                    ]
                ];
            case activity_1.ACTIVITY_TYPE.PET:
                return [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_pet_1")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_pet_2"))
                    ], [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_pet_3")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_pet_4"))
                    ]
                ];
        }
    };
    HomeState.prototype.roar = function () {
        var _this = this;
        this._dragonContainer.setRoarAnimation(function (on) {
            var breath = _this._client.dragon.appearance.breath;
            _this.breathEmitter.configureAppearance(breath);
            _this.breathEmitter.emit = on;
            if (!on) {
                _this._client.adjustMeters({
                    calmness: 0,
                    nutrition: 0,
                    hygiene: 0,
                    energy: 25
                });
                _this._client.award(calculator_1.ROAR_XP);
                _this._client.synchronize();
                _this._client.sendEvent("home_roared", {
                    breath: breath
                });
            }
        });
    };
    HomeState.prototype.onName = function () {
        this.stateMachine.push(name_state_1.default);
    };
    HomeState.prototype.onGift = function () {
        this.stateMachine.push(scoring_state_1.default);
    };
    HomeState.prototype.checkActivityRequirements = function (type) {
        if (!this.activityRequiresHatched(type) || calculator_1.default.hatched(this._client.dragon.status.stage)) {
            return true;
        }
        var title = i18next_1.default.t(type + "_title");
        var messages = [
            new guide_1.GuideMessage(i18next_1.default.t("guide_activity_requires_hatched_1")),
            new guide_1.GuideMessage(i18next_1.default.t("guide_activity_requires_hatched_2"))
        ];
        this._guide.setPages([messages]);
        this.stateMachine.push(guide_state_1.default);
        return false;
    };
    HomeState.prototype.checkActivityGuide = function (type) {
        var _this = this;
        if (this._client.dragon.status.seenActivities.includes(type)) {
            this.pushActivity(type);
            return false;
        }
        var pages = this.activityGuidePages(type);
        this._guide.setPages(pages, function () {
            _this._client.dragon.status.seenActivities.push(type);
            _this._client.synchronize();
            _this.pushActivity(type);
        });
        this.stateMachine.push(guide_state_1.default);
        return true;
    };
    HomeState.prototype.pushActivity = function (type) {
        var stateClass = this.activityStateClass(type);
        if (stateClass) {
            this.stateMachine.push(stateClass);
        }
    };
    HomeState.prototype.onActivity = function (type) {
        if (!this.checkActivityRequirements(type)) {
            return;
        }
        this.checkActivityGuide(type);
    };
    return HomeState;
}(state_1.default));
exports.default = HomeState;
